import { ReactNode } from 'react';
import { Mail } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useLocale } from '../../Shared/locale';
import { Campaign, SentMail } from '../../Shared/types';
import { Card } from '../../Shared/UI/Card';
import { Icon } from '../../Shared/UI/Icon';
import { useRouter } from '../router';
import Container from '../UI/Container';
import Layout from '../UI/Layout';
import { CampaignLayout } from './CampaignLayout';

export default function SentMailsPage({
  sentMails,
}: {
  campaign: Campaign;
  sentMails: SentMail[];
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const { formatDate } = useLocale();

  return (
    <Container className="space-y-6">
      <Card panels spacing="sm">
        {sentMails.map((sentMail) => (
          <div className="grid grid-cols-[3fr_1fr] !py-4" key={sentMail.id}>
            <div className="font-medium">
              <a
                href={routes.sent_mail(sentMail.id)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-800"
              >
                <Icon className="mr-1">
                  <Mail />
                </Icon>
                {sentMail.subject}
              </a>
            </div>
            <div className="text-right text-slate-500">
              {formatDate(sentMail.created_at, 'display_date_time')}
            </div>
          </div>
        ))}
        {sentMails.length === 0 && (
          <div className="text-center text-slate-500 py-24">
            {t('backend:no_results')}
          </div>
        )}
      </Card>
    </Container>
  );
}

SentMailsPage.layout = (page: ReactNode) => <Layout><CampaignLayout>{page}</CampaignLayout></Layout>;
